import src from "IMAGE";
export default { src, width: 256, height: 256 }
